import { render, staticRenderFns } from "./TakeawayOrderDetailInfo.vue?vue&type=template&id=48106ed2&scoped=true"
import script from "./TakeawayOrderDetailInfo.vue?vue&type=script&lang=js"
export * from "./TakeawayOrderDetailInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48106ed2",
  null
  
)

export default component.exports